import { TextKey } from '@mews-commander/enums';
import { Stack, Typography } from '@optimus-web/core';
import { SepaPaymentMethodStatus } from '@mews-commander/data-access';
import { Dash, LocalizedLabel, SpacedColon } from '@mews-commander/ui';
import { PaymentMethodStatusHistoryBodyReservations } from './PaymentMethodStatusHistoryBodyReservations';
import { PaymentMethodStatusHistoryBodyWrapper } from './PaymentMethodStatusHistoryBodyWrapper';

export const SepaStatusHistoryBody = ({
    status: { source, creatorProfileName, propertyName, reservationReferenceIdentifiers, mandateReference },
}: {
    status: SepaPaymentMethodStatus;
}) => (
    <PaymentMethodStatusHistoryBodyWrapper>
        <LocalizedLabel
            textKey={TextKey.PaymentMethodCapturedByUserAtProperty}
            variant="secondary"
            substitutes={{ source, user: creatorProfileName, property: propertyName }}
            as="div"
        />
        <PaymentMethodStatusHistoryBodyReservations reservations={reservationReferenceIdentifiers} />
        <SepaStatusHistoryBodyMandate mandateReference={mandateReference} />
    </PaymentMethodStatusHistoryBodyWrapper>
);

const SepaStatusHistoryBodyMandate = ({ mandateReference }: Pick<SepaPaymentMethodStatus, 'mandateReference'>) => (
    <Stack>
        <LocalizedLabel textKey={TextKey.PaymentMethodHistorySepaMandateReference} variant="secondary" as="div" />
        {SpacedColon}
        {mandateReference ? (
            <Typography textStyle="bodyMediumStrong" as="div">
                {mandateReference}
            </Typography>
        ) : (
            <Dash />
        )}
    </Stack>
);
